import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { useTranslation } from 'react-i18next';
import logoutUser from 'utils/auth/logout';
import { redirectToLogin } from 'utils/auth/getLogoutPath';
import useCustomContactLink from 'hooks/useCustomContactLink';
import Pill from 'components/Pill';
import VisuallyHidden from 'components/VisuallyHidden';
import { NavMenu, NavMenuList, NavMenuItem, NavMenuButton, NavMenuDivider, NavMenuItemGroup } from 'components/NavMenu';
import { useFetchUserProfile } from 'actions/userProfile';
import { setAlert } from 'actions/alerts';
import { useAuthContext } from '../../../contexts/auth';
import AddToHomeScreenLink from './AddToHomescreen';
import { NavMenuRouterLinkItem } from './NavMenuRouterLinkItem';
import { AdminAndManagerLinks } from './AdminAndManagerLinks';
import CustomUserMenuLinks from './CustomUserMenuLinks';
import getUserDisplayName from './getUserDisplayName';
import { useUnreadCount } from './useUnreadCount';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function UserMenu() {
  var _useAuthContext = useAuthContext(),
    setAuthUser = _useAuthContext.setAuthUser;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFetchUserProfile = useFetchUserProfile(),
    userProfile = _useFetchUserProfile.data;
  var contactLink = useCustomContactLink();
  var unreadCount = useUnreadCount();
  function logout(_x) {
    return _logout.apply(this, arguments);
  }
  function _logout() {
    _logout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            _context.prev = 1;
            _context.next = 2;
            return logoutUser();
          case 2:
            setAuthUser(null);
            redirectToLogin();
            _context.next = 4;
            break;
          case 3:
            _context.prev = 3;
            _t = _context["catch"](1);
            setAlert({
              title: t('alert_logout_failed'),
              message: _t === null || _t === void 0 ? void 0 : _t.error
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 3]]);
    }));
    return _logout.apply(this, arguments);
  }
  var userSectionHeading = getUserDisplayName(userProfile) || t('property_settings');
  var hasUnreadNotifications = unreadCount > 0;
  return /*#__PURE__*/_jsxs(NavMenu, {
    menuPositionFixed: true,
    menuPlacement: "bottom-end",
    children: [/*#__PURE__*/_jsx(NavMenuButton, {
      iconOnly: true,
      icon: "tools",
      variant: "transparent",
      children: /*#__PURE__*/_jsx(VisuallyHidden, {
        children: t('actions_toggle_nav')
      })
    }), /*#__PURE__*/_jsxs(NavMenuList, {
      children: [/*#__PURE__*/_jsxs(NavMenuItemGroup, {
        label: userSectionHeading,
        children: [/*#__PURE__*/_jsx(NavMenuRouterLinkItem, {
          to: "/settings",
          children: t('navbar_user_settings')
        }), /*#__PURE__*/_jsxs(NavMenuRouterLinkItem, {
          to: "/inbox",
          id: "inbox",
          text: t('navbar_inbox'),
          children: [t('navbar_inbox'), hasUnreadNotifications && /*#__PURE__*/_jsx(Pill, {
            role: "alert",
            ml: "xxs",
            "aria-label": t('unread_messages', {
              count: unreadCount
            }),
            background: "highlight",
            children: unreadCount
          })]
        }), contactLink.url ? /*#__PURE__*/_jsx(NavMenuItem, {
          as: "a",
          href: contactLink.url,
          target: "_blank",
          children: contactLink.title
        }) : /*#__PURE__*/_jsx(NavMenuItem, {
          as: "button",
          onClick: contactLink.openModal,
          children: contactLink.title
        })]
      }), /*#__PURE__*/_jsx(CustomUserMenuLinks, {}), /*#__PURE__*/_jsx(AddToHomeScreenLink, {}), /*#__PURE__*/_jsx(AdminAndManagerLinks, {}), /*#__PURE__*/_jsx(NavMenuDivider, {}), /*#__PURE__*/_jsx(NavMenuItem, {
        id: "log_out_button",
        onClick: logout,
        children: t('actions_logout')
      })]
    })]
  });
}
export default UserMenu;